// src/components/Footer.jsx
import React from 'react';

function Footer() {
  return (
    <footer className="footer bg-primary text-white text-center py-3 mt-auto">
      <p className="mb-0">&copy; 2025 Vismit Radiology Center. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
